import { CardContent, CardContentWithoutEK } from '@src/components/Editor/types'
import { CardActionsState } from '@src/state/checks/actions'
import { getPlainText } from '@src/state/document/selectors'
import { RootState } from '@src/state/types'
import { BUTTON } from '@src/state/userevents/actions'
import { getWordCount } from '@src/utils/wordCount'
import { cardActionToInteractionTypeMap, EVENT_TYPES } from '../constants'
import { clickstreamInteractionEvent } from '../definitions'
import { ProductContentMetadata1, WtInteraction } from '../rsw/eventSchemas'
import { EventWithConfig } from '../types'
import getAutoFixable from './getAutoFixable'

const cardToCardEngagement = (
  card: CardContent | CardContentWithoutEK,
  interaction: WtInteraction,
  id: string,
  selectedReplacement?: string
): EventWithConfig => {
  return {
    payload: {
      type: EVENT_TYPES.CARD_ENGAGEMENT,
      data: {
        id: card.id,
        rule: card.rule,
        interaction,
        upload_id: id,
        index_highlighted_start: card.start,
        index_highlighted_end: card.end,
        check_type: card.type,
        category: card.category,
        model_type: card.analytics ? card.analytics.model_type : undefined,
        index_sentence_start: card.analytics ? card.analytics.sentence_start : undefined,
        index_sentence_end: card.analytics ? card.analytics.sentence_end : undefined,
        auto_fixable: getAutoFixable(card.replacements),
        model_name: card.analytics ? card.analytics.model_name : undefined,
        accepted_replacement: selectedReplacement ? selectedReplacement : undefined,
      },
    },
    config: { eventVersion: 5 },
  }
}

export const cardToClickstreamInteraction = (
  card: CardContent | CardContentWithoutEK,
  cardAction: CardActionsState,
  id: string,
  prevState: RootState,
  nextState: RootState
): EventWithConfig => {
  return clickstreamInteractionEvent(
    {
      payload: {
        element: 'writing card',
        type: BUTTON,
        interactionType: cardActionToInteractionTypeMap[cardAction],
        metadata: cardToClickstreamMetadata(card, id, prevState),
      },
    },
    prevState,
    nextState
  )
}

export const cardToClickstreamMetadata = (
  card: CardContent | CardContentWithoutEK,
  id: string,
  prevState: RootState
): ProductContentMetadata1 => {
  const text = getPlainText(prevState)

  return {
    wt: {
      writing: {
        check_type: card.type,
        upload_id: id,
        word_count: getWordCount(text),
        index_highlighted_start: card.start,
        index_highlighted_end: card.end,
        card_id: card.id,
        rule: card.rule,
        category: card.category,
        model_type: card.analytics ? card.analytics.model_type : undefined,
        index_sentence_start: card.analytics ? card.analytics.sentence_start : undefined,
        index_sentence_end: card.analytics ? card.analytics.sentence_end : undefined,
        auto_fixable: getAutoFixable(card.replacements),
        model_name: card.analytics ? card.analytics.model_name : undefined,
      },
    },
  }
}

export default cardToCardEngagement



// WEBPACK FOOTER //
// ./src/state/analytics/utils/cardInteractionToEvent.ts